module.exports = __webpack_public_path__ + "static/Writers-Print (4)-3081a9bde6497949b9792622d97f0950.png";